module.exports = __webpack_public_path__ + "static/media/MierA-Thin.61d2a103.ttf";